export default {
    getAllSecurities: () => {
        return {
            url: '/myfhe/securities',
            method: 'GET'
        };
    },
    getSecurityDetails: securityId => {
        return {
            url: '/myfhe/securities/:securityId',
            method: 'GET',
            route_params: {
                securityId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/Security/api.js